import { render, staticRenderFns } from "./AIForwardLooking.vue?vue&type=template&id=8f0a7d94&scoped=true"
import script from "./AIForwardLooking.vue?vue&type=script&lang=js"
export * from "./AIForwardLooking.vue?vue&type=script&lang=js"
import style0 from "./AIForwardLooking.vue?vue&type=style&index=0&id=8f0a7d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0a7d94",
  null
  
)

export default component.exports